import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Modal,
  Typography,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useParams } from 'react-router-dom';
import { useCompanyAssigned } from '../../CompanyAssignedContext';
import perfil from '../../../images/user.png';
import { ApiService } from '../../ApiService';
import { ModalVistaTrabajador } from '../../ModalVistaTrabajador'; /* componente modal */

const colorClasses = [
  'team-green',
  'team-piel txt-black',
  'team-yellow-dark txt-black',
  'team-blue',
  'team-green-dark',
  'team-yellow txt-black'
];

const HomeEquipoEdit = ({ key_branch }) => {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // ✅ Añade tu baseURL:
  const API_url = process.env.REACT_APP_API_URL;

  const { nit } = useParams();
  const { companyAssigned = [] } = useCompanyAssigned() || [];

  const [trabajadorSeleccionado, setTrabajadorSeleccionado] = useState(null);
  const [modalVistaOpen, setModalVistaOpen] = useState(false);

  const handleVistaTrabajador = (user) => {
    setTrabajadorSeleccionado({
      ...user,
      profile: user.profile ? `${user.profile}` : null
    });
    setModalVistaOpen(true);
  };

  const handleCloseVista = () => {
    setModalVistaOpen(false);
    setTrabajadorSeleccionado(null);
  };


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await ApiService.fetchData(
          `api/company/user/global-list?key_branch=${key_branch}`,
          { method: 'GET' }
        );
        if (Array.isArray(data)) {
          setUsers(data);
          // Marcar localmente los seleccionados
          const preSeleccionados = data
            .filter(u => u.selected)
            .map(u => u.key_user);
          setSelectedUsers(preSeleccionados);
        }
      } catch (error) {
        console.error('Error cargando usuarios:', error);
      }
    };
    fetchUsers();
  }, [key_branch]);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleToggleUser = async (key_user) => {
    const isSelected = selectedUsers.includes(key_user);

    // Actualizar en local
    setSelectedUsers(prev =>
      isSelected ? prev.filter(u => u !== key_user) : [...prev, key_user]
    );

    // PUT en backend
    try {
      await ApiService.fetchData(
        `api/company/user/view?key_branch=${key_branch}&key_user=${key_user}`,
        { method: 'PUT' }
      );
    } catch (error) {
      console.error('Error al actualizar usuario en backend:', error);
    }
  };

  // Usuarios seleccionados para mostrar en la página
  const displayedUsers = users.filter(u => selectedUsers.includes(u.key_user));

  // Filtro para el modal
  const filteredUsers = users.filter(u => {
    const term = searchTerm.toLowerCase();
    return (
      u.fullName.toLowerCase().includes(term) ||
      (u.phone && u.phone.includes(term))
    );
  });

  return (
    <div className='team-company'>
      <div className="team-title">
        <hr className="line" style={{ background: 'var(--theme-company)' }} />
        <h2>
          NUESTRO EQUIPO DE <span style={{ color: 'var(--theme-company)' }}>TRABAJO</span>
        </h2>
        <hr className="line" style={{ background: 'var(--theme-company)' }} />
      </div>

      <div className='team-people'>
        {displayedUsers.map((user, idx) => (
          <div
            key={user.key_user}
            className={`card-team ${colorClasses[idx % colorClasses.length]}`}
            onClick={() => handleVistaTrabajador(user)} // ✅ abre el modal con datos del usuario
            style={{ cursor: 'pointer' }}
          >

            <div className='section-team'>
              {/* Cargo / puesto del usuario */}
              <h2>
                {user.job
                  ?.split(' ')
                  .map((word, i) => (
                    <React.Fragment key={i}>
                      {word}<br />
                    </React.Fragment>
                  ))}
              </h2>
            </div>
            <div className='section-team team-img'>
              <img
                src={user.profile ? API_url + user.profile : perfil}
                alt="perfil"
                style={{ marginTop: '10px', marginBottom: '20px' }}
              />
            </div>
            <div className='section-team'>
              <h3>{user.fullName}</h3>
              {/* <p style={{ fontSize: '14px' }}>Tel: {user.phone}</p> */}
            </div>
            <div className="glow-wrap">
              <i className="glow"></i>
            </div>
          </div>
        ))}

        {/* Botón para añadir usuarios */}
        <div
          className='card-team add-card'
          onClick={handleOpenModal}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <Typography variant='body2'>Agregar Usuario</Typography>
          <AddIcon sx={{ fontSize: 40 }} />
        </div>
      </div>

      {/* MODAL para listar/filtrar usuarios */}
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            width: {
              xs: '98%', // 98% del ancho en móviles
              md: 500    // 500px en pantallas medianas en adelante
            },
            bgcolor: 'white',
            p: {
              xs:1,
              md:3,
            },
            borderRadius: 2,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Typography variant='h6' align='center' gutterBottom>
            Lista de usuarios
          </Typography>

          {/* Buscador */}
          <TextField
            placeholder="Buscar por nombre o teléfono"
            fullWidth
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Nombre</strong></TableCell>
                  <TableCell><strong>Puesto</strong></TableCell>
                  <TableCell><strong>Teléfono</strong></TableCell>
                  <TableCell><strong>Ver</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredUsers.map((user) => {
                  const isChecked = selectedUsers.includes(user.key_user);
                  return (
                    <TableRow key={user.key_user}>
                      <TableCell>{user.fullName}</TableCell>
                      <TableCell>{user.job}</TableCell>
                      <TableCell>{user.phone}</TableCell>
                      <TableCell>
                        <Checkbox
                          checked={isChecked}
                          onChange={() => handleToggleUser(user.key_user)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          <Box textAlign="center" mt={2}>
            <Button
              variant='contained'
              onClick={handleCloseModal}
              sx={{ px: 5 }}
            >
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal>
      <ModalVistaTrabajador
        open={modalVistaOpen}
        onClose={handleCloseVista}
        trabajador={trabajadorSeleccionado}
      />

    </div>
  );
};

export default HomeEquipoEdit;
